import { Component } from "@angular/core";
import { MdDialog, MdDialogRef, MdSnackBar } from "@angular/material";
import { LicenseService } from "../../services/LicenseService";
import { AppLoaderService } from "../../../services/app-loader/app-loader.service";
import Swal from "sweetalert2";
import { SCALOperations, SCALType } from "../../interfaces/LicenseModel";

import { ActivatedRoute, Router } from "@angular/router";
import { AdalService } from "../../shared/adal.service";
import { ExportToCSVService } from "../../services/ExportToCSVService";
import { PagerService } from "../../services/PagerService";
import { UserService } from "../../services/UserService";
import { SyncITFilterPipe } from "./pipes/SyncITFilterPipe";
import { GenerateSyncITLicenseComponent } from "./popup/generate-syncit-license/generate-syncit-license.component";
import { ExtendSyncItTrialPeriodComponent } from "./popup/extend-trial-period/extend-trial-period.component";
import { AddMoreSyncItLicenseComponent } from "./popup/addmore-syncit-license/addmore-syncit-license.component";
import { RenewSyncItComponent } from "./popup/renew-syncit-license/renew-syncit-license.component";
import { ViewSyncItHistoryComponent } from "./popup/view-history-popup/view-history-popup.component";
import * as constants from "./constants";

@Component({
  selector: "license-syncit",
  template: require('./syncit.component.html'),
  styles: [require('./syncit.component.css')],
})
export class LicenseModuleSyncITComponent {
  MAX_TRIAL_INSTRUMENTS = constants.MAX_TRIAL_INSTRUMENTS;
  filterBillToName = "";
  filterShipToName = "";

  searchBillToName = "";
  searchShipToName = "";

  syncITproducts: any = [];

  BillToList = [];
  ShipToList = [];

  SyncITLicenseList = [];
  originalSyncITLicenseList = [];
  filteredScal360LicenseList = [];

  filterClientAdminEmail = "";
  searchClientAdminEmail = "";

  errorMessage = "";
  SCALTypeList = [];
  expandedRow = null;
  isLoading = false;
  customerLicenseDetails = [];
  pager: any = {};
  pagedItems = [];
  IsAddEdit;
  IsDelete;
  ProductId;
  currentSortColumn: string = "";
  currentSortOrder: string = "";
  constructor(
    private dialog: MdDialog,
    private licenseService: LicenseService,
    private appLoader: AppLoaderService,
    private snackBar: MdSnackBar,
    private adalService: AdalService,
    private router: Router,
    private exportService: ExportToCSVService,
    private route: ActivatedRoute,
    private pagerService: PagerService,
    private userService: UserService,
    private filterPipe: SyncITFilterPipe,
  ) {
    if (!this.adalService.getCachedToken()) {
      setTimeout(() => {
        this.router.navigate(["login"]);
      }, 100);
    }

    appLoader.close();
    route.params.subscribe((params) => {
      this.ProductId = params["productId"];
    });
    this.getUserRights();
    this.getSyncITProducts();
    this.appLoader.open();
    this.getSyncITLicenseDetails();
  }

  getUserRights() {
    let UserId = Number(localStorage.getItem("userid"));
    this.userService
      .getUserLicenseRightById(UserId, this.ProductId)
      .subscribe((data) => {
        if (!data.IsError && data.DataObject != null) {
          this.IsAddEdit = data.DataObject.IsAddEdit;
          this.IsDelete = data.DataObject.IsDelete;
        }
      });
  }

  setPage(page: number) {
    this.SyncITLicenseList = [...this.originalSyncITLicenseList];
    this.applySort();
    this.filteredScal360LicenseList = this.filterPipe.transform(
      this.SyncITLicenseList,
      this.filterBillToName,
      this.filterShipToName,
      this.filterClientAdminEmail,
    );
    this.pager = this.pagerService.getPager(
      this.filteredScal360LicenseList.length,
      page,
    );
    this.pagedItems = this.filteredScal360LicenseList.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1,
    );
    this.errorMessage = this.pagedItems.length == 0 ? "No records found." : "";
  }

  exportToCSV() {
    let jsonData: Array<any> = [];
    if (this.SyncITLicenseList) {
      this.SyncITLicenseList.forEach((element) => {
        jsonData.push({
          BillToName: element.BillToName,
          BillToAddress1: element.BillToAddress1,
          BillToAddress2: element.BillToAddress2,
          BillToCity: element.BillToCity,
          BillToState: element.BillToState,
          BillToCountry: element.BillToCountry,
          ShipToName: element.ShipToName,
          ShipToAddress1: element.ShipToAddress1,
          ShipToAddress2: element.ShipToAddress2,
          ShipToCity: element.ShipToCity,
          ShipToState: element.ShipToState,
          ShipToCountryCode: element.ShipToCountryCode,
          ClientAdminEmail: element.ClientAdminEmail,
          ExpiryDate: element.ExpiryDate,
          LicenseType: element.LicenseType,
          ProductWiseInstrumentCount: element.ProductWiseInstrumentCount
            ? element.ProductWiseInstrumentCount.replace(
                /<br\s*\/?>/gi,
                ", ",
              ).replace(/\r?\n/g, ", ")
            : "",

          UpdatedDate: element.UpdatedDate,
        });
      });
      this.exportService.exportToCsv(jsonData, "SyncIT");
    } else {
      Swal.fire({
        title: "No data",
        text: "There is no data available to export to CSV file.",
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#FFCA28",
      });
    }
  }
  clearSearch() {
    this.searchBillToName = this.filterBillToName = "";
    this.searchShipToName = this.filterShipToName = "";
    this.searchClientAdminEmail = this.filterClientAdminEmail = "";
    this.expandedRow = null;
    this.setPage(1);
  }
  search() {
    this.filterBillToName = this.searchBillToName;
    this.filterShipToName = this.searchShipToName;
    this.filterClientAdminEmail = this.searchClientAdminEmail;
    this.expandedRow = null;
    this.setPage(1);
  }
  getSyncITLicenseDetails() {
    this.licenseService.getSyncItLicenseDetails().subscribe((data) => {
      if (!data.IsError && data.DataObject != null) {
        this.originalSyncITLicenseList = data.DataObject;
        this.SyncITLicenseList = [...this.originalSyncITLicenseList];
        this.setPage(1);
        this.buildSearchArray();
      } else {
      }
      this.appLoader.close();
    });
  }

  buildSearchArray() {
    const BillToArray = this.SyncITLicenseList.map((item) => item.BillToName);
    const ShipToArray = this.SyncITLicenseList.map((item) => item.ShipToName);
    this.BillToList = Array.from(new Set(BillToArray)).sort();
    this.ShipToList = Array.from(new Set(ShipToArray)).sort();
  }

  onSortChange(event) {
    this.currentSortColumn = event.column;
    this.currentSortOrder = event.order;

    if (this.pager && this.pager.currentPage) {
      this.setPage(this.pager.currentPage);
    } else {
      this.setPage(1);
    }
  }

  applySort() {
    if (!this.currentSortColumn || !this.currentSortOrder) {
      return;
    }

    this.SyncITLicenseList.sort(
      function (a, b) {
        var valA = a[this.currentSortColumn];
        var valB = b[this.currentSortColumn];

        valA = valA === null || valA === undefined ? "" : valA;
        valB = valB === null || valB === undefined ? "" : valB;

        // DATE columns
        if (this.currentSortColumn.toLowerCase().indexOf("date") !== -1) {
          var dateA = new Date(valA).getTime() || 0;
          var dateB = new Date(valB).getTime() || 0;

          return this.currentSortOrder === "asc"
            ? dateA - dateB
            : dateB - dateA;
        }

        // NUMBER columns
        if (!isNaN(valA) && !isNaN(valB)) {
          return this.currentSortOrder === "asc"
            ? Number(valA) - Number(valB)
            : Number(valB) - Number(valA);
        }

        // HTML column
        if (this.currentSortColumn === "ProductWiseInstrumentCount") {
          valA = valA.toString().replace(/<[^>]*>/g, "");
          valB = valB.toString().replace(/<[^>]*>/g, "");
        }

        // STRING compare
        valA = valA.toString();
        valB = valB.toString();

        return this.currentSortOrder === "asc"
          ? valA.localeCompare(valB)
          : valB.localeCompare(valA);
      }.bind(this),
    );
  }

  openGenerateNewLicenseRequestDialog() {
    let generateNewLicenseRequestDialogRef: MdDialogRef<GenerateSyncITLicenseComponent> =
      this.dialog.open(GenerateSyncITLicenseComponent, {
        width: "60%",
        height: "94%",
        data: {
          syncITproducts: this.syncITproducts,
          SyncITLicenseData: this.SyncITLicenseList,
          dialogTitle: "Generate New License",
        },
        disableClose: true,
      });
    generateNewLicenseRequestDialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getSyncITLicenseDetails();
      }
    });
  }

  openExtendTrial(row) {
    if (row.LicenseType.toLowerCase() == "trial") {
      let ExtendSyncItTrialPeriodRef: MdDialogRef<ExtendSyncItTrialPeriodComponent> =
        this.dialog.open(ExtendSyncItTrialPeriodComponent, {
          width: "50%",
          height: "30%",
          data: {
            payload: row,
          },
          disableClose: true,
        });
      ExtendSyncItTrialPeriodRef.afterClosed().subscribe((result) => {
        if (result) {
          this.appLoader.open();
          this.licenseService.ExtendTrialRenewPeriod(result).subscribe({
            next: (data) => {
              if (data.IsError == true) {
                this.appLoader.close();
                this.snackBar.open(data.Error, "Close", {
                  duration: 3000,
                });
                return;
              }
              this.getSyncITLicenseDetails();
              this.snackBar.open("Trial Period Extend Successfully", "Close", {
                duration: 3000,
              });
            },
            error: (err) => {
              this.snackBar.open(err.error.message, "Close", {
                duration: 3000,
              });
            },
          });
        }
      });
    } else {
      let RenewSyncItComponentRef: MdDialogRef<RenewSyncItComponent> =
        this.dialog.open(RenewSyncItComponent, {
          width: "50%",
          height: "30%",
          data: {
            payload: row,
          },
          disableClose: true,
        });
      RenewSyncItComponentRef.afterClosed().subscribe((result) => {
        if (result) {
          this.licenseService.ExtendTrialRenewPeriod(result).subscribe({
            next: (data) => {
              if (data.IsError == true) {
                this.appLoader.close();
                this.snackBar.open(data.Error, "Close", {
                  duration: 3000,
                });
                return;
              }
              this.getSyncITLicenseDetails();
              this.snackBar.open("License Renew Successfully", "Close", {
                duration: 3000,
              });
            },
            error: (err) => {
              this.snackBar.open(err.error.message, "Close", {
                duration: 3000,
              });
            },
          });
        }
      });
    }
  }

  openSyncItLicenseHistory(row) {
    let activationHistoryDialogRef: MdDialogRef<ViewSyncItHistoryComponent> =
      this.dialog.open(ViewSyncItHistoryComponent, {
        width: "60%",
        height: "70%",
        data: {
          SyncITProductLicenseId: row.SyncITProductLicenseId,
        },
        disableClose: true,
      });
    activationHistoryDialogRef.afterClosed().subscribe((result) => {});
  }

  addMoreLicense(row) {
    let AddMoreLicenseComponentRef: MdDialogRef<AddMoreSyncItLicenseComponent> =
      this.dialog.open(AddMoreSyncItLicenseComponent, {
        width: "70%",
        height: "94%",
        data: {
          SyncITProductLicenseId: row.SyncITProductLicenseId,
          LicenseType: row.LicenseType,
        },
        disableClose: true,
      });
    AddMoreLicenseComponentRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getSyncITLicenseDetails();
      }
    });
  }

  getSyncITProducts() {
    this.licenseService.getSyncITProducts().subscribe((data) => {
      if (!data.IsError && data.DataObject != null) {
        this.syncITproducts = data.DataObject;
      }
    });
  }

  approveTrailPeriodExtension(row) {
    Swal.fire({
      title: "Approve Trial Period Extension",
      text: "Are you sure you want to approve trial period extension?",
      showCancelButton: true,
      showCloseButton: true,
      showConfirmButton: true,
      confirmButtonColor: "#FFCA28",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    }).then((result) => {
      if (result.isConfirmed) {
        this.appLoader.open();
        let model = {
          SyncITProductLicenseId: row.SyncITProductLicenseId,
          UpdatedBy: Number(localStorage.getItem("userid")),
        };
        this.licenseService
          .approveTrialPeriodExtension(model)
          .subscribe((data) => {
            if (!data.IsError && data.DataObject != null) {
              this.licenseService
                .getSyncItLicenseDetails()
                .subscribe((data) => {
                  if (!data.IsError && data.DataObject != null) {
                    this.originalSyncITLicenseList = data.DataObject;
                    this.SyncITLicenseList = [
                      ...this.originalSyncITLicenseList,
                    ];
                    this.setPage(1);
                    this.buildSearchArray();
                  } else {
                  }
                  this.appLoader.close();
                });
            } else {
              this.appLoader.close();
              Swal.fire({
                title: "Error",
                text: data.Error,
                showConfirmButton: true,
                confirmButtonColor: "#FFCA28",
              });
              return;
            }
          });
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/syncit/syncit.component.ts